import { CallHistoryMethodAction, push } from 'connected-react-router';
import { isExternalClient, isNetquestClient, isPureProfileClient } from './clients';
import { isDevelopEnv, isOnlyProduction, isOnlyRelease } from './platform';
import { ADMIN_ENABLED_ACCOUNTS_IDS, ENV } from '../config';

const SECONDS_IN_A_MINUTE = 60;

export const isEmpty = (object: unknown): boolean | undefined => {
  if (Array.isArray(object)) {
    return !object.length;
  }
  if (typeof object === 'object') {
    return !Object.keys(object || {}).length;
  }
};

export const getCookie = (name: string): string => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() ?? '';
  }
  return '';
};

export const redirectToUpgradeToPro = (): CallHistoryMethodAction<[string, unknown?]> => push('/settings/subscription/upgrade-to-pro');

const getEnvSuffix = () => {
  if (isDevelopEnv()) {
    return '-Dev';
  }
  if (isOnlyRelease()) {
    return '-Staging';
  }
  if (isOnlyProduction()) {
    return '';
  }
  return `-${ENV}`;
};

export const getAppTitle = (): string => {
  const envSuffix = getEnvSuffix();
  if (isPureProfileClient()) {
    return 'Datarubico' + envSuffix;
  }
  if (isNetquestClient()) {
    return 'Flash Survey' + envSuffix;
  }
  return 'SightX' + envSuffix;
};

export const parseCommaSeparatedValues = (idsString = ''): string[] => idsString.split(',').filter(id => id.length > 0);

export const parseError = (err: unknown, defaultMessage?: string): string => {
  if (typeof err === 'string') {
    return err;
  }

  if (typeof err === 'object' && err && 'message' in err && err.message && typeof err.message === 'string') {
    return err.message;
  }

  if (defaultMessage) {
    return defaultMessage;
  }

  return JSON.stringify(err);
};

export const getMinutesAndSecondsRemaining = (totalSeconds: number): { minutes: number; seconds: number } => {
  const truncatedSeconds = Math.trunc(totalSeconds);
  const seconds = truncatedSeconds % SECONDS_IN_A_MINUTE;
  const minutes = (truncatedSeconds - seconds) / SECONDS_IN_A_MINUTE;
  return { minutes, seconds };
};

export const isRepDataAccount = (accountId: string): boolean => ADMIN_ENABLED_ACCOUNTS_IDS.has(accountId) && !isExternalClient();
